import axios, { AxiosResponse } from 'axios';
import rateLimit from 'axios-rate-limit';
import requestInterceptor from '@/services/api/interceptors/request.interceptor';
import errorInterceptor from '@/services/api/interceptors/error.interceptor';
import cancelInterceptor from '@/services/api/interceptors/cancel.interceptor';

export const api = rateLimit(
  axios.create({
    baseURL: '/api',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    }
  }), 
  { 
    maxRequests: 2, 
    perMilliseconds: 1000, 
    maxRPS: 2 
  });

api.interceptors
  .request.use(requestInterceptor);
api.interceptors
  .request.use(cancelInterceptor);

api.interceptors
  .response.use((response: AxiosResponse) => response, errorInterceptor);
